var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass:
        "step-content-container step-content-container-trial__step-2 flex-level jc-center wp-10"
    },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wp-5 p-8 acenter",
          staticStyle: { "max-width": "640px" }
        },
        [
          _c("onboarding-trial-illustration", {
            attrs: { lang: _vm.currentLang }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wp-5 p-8 bl-1 flex-column",
          staticStyle: { "max-width": "640px" }
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("h2", { staticClass: "m-0" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Créez votre compte")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 gray-60 m-0 mb-3 semibold" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Afin de pouvoir démarrer votre essai")) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: { labelPosition: "top", model: _vm.form, rules: _vm.rules }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.your_email_address"),
                    prop: "login",
                    error: _vm.errors.get("login")
                  }
                },
                [
                  _c("text-input", {
                    attrs: {
                      mode: "edit",
                      value: _vm.form.login,
                      placeholder: _vm.$t.__(
                        "pages.onboarding.trial.OnboardingTrialStep1.username_to_connect_to_sellsy"
                      )
                    },
                    on: { input: _vm.updateLogin }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "mb-4",
                  attrs: {
                    label: _vm.$t.__(
                      "pages.onboarding.trial.OnboardingTrialStep1.define_password"
                    ),
                    prop: "password",
                    error: _vm.errors.get("password")
                  }
                },
                [
                  _c("password-input", {
                    attrs: {
                      mode: "edit",
                      value: _vm.form.password,
                      placeholder: _vm.$t.__(
                        "pages.onboarding.trial.OnboardingTrialStep1.to_secure_account_access"
                      )
                    },
                    on: { input: _vm.updatePassword }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "mb-4",
                  attrs: { prop: "terms", error: _vm.errors.get("terms") }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "flex-row",
                      attrs: { value: _vm.form.terms },
                      on: { input: _vm.updateTerms }
                    },
                    [
                      _c("span", {
                        staticClass: "label label-nobackground p-0 fs-3",
                        domProps: {
                          innerHTML: _vm._s(_vm.termsLabelLegalInformation)
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "p-0 mt-2 mb-1 fs-3",
                        domProps: {
                          innerHTML: _vm._s(_vm.termsLabelPrivatePolicy)
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "flex-row",
                      attrs: { value: _vm.form.mailing },
                      on: { input: _vm.updateMailing }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "label label-nobackground p-0 fs-3" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Je souhaite être informé des actualités, publications et offres de Sellsy"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action self-center" },
            [
              _c("CompassButton", {
                staticClass: "self-center",
                attrs: {
                  label: _vm.$t.__(
                    "pages.onboarding.trial.OnboardingTrialStep1.create_account_and_continue"
                  ),
                  type: "primary",
                  disabled: _vm.isDisabledNextStep
                },
                on: {
                  click: function($event) {
                    return _vm.submitForm("form", "goToNextStep")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "bb-1 wp-10 my-4 acenter separator" }, [
            _c("span", { staticClass: "grey white-bkg px-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Ou")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action self-center flex-column ai-center" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t.__(
                      "pages.onboarding.trial.OnboardingTrialStep1.please_accept_terms_before_registring_with_google"
                    ),
                    placement: "top",
                    disabled: _vm.form.terms
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "CompassButton",
                        {
                          attrs: {
                            label: _vm.$t.__(
                              "common.actions.subscribe_with_google"
                            ),
                            type: "secondary",
                            disabled: !_vm.form.terms
                          },
                          on: {
                            click: function($event) {
                              return _vm.signUpGoogle()
                            }
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "prefix" },
                            [
                              _c(
                                "icon-svg",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    iconName: "google",
                                    width: 20,
                                    height: 20,
                                    viewBox: "0 0 24 24"
                                  }
                                },
                                [_c("icon-google")],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }